import React from 'react';
import Reveal from './Reveal';

const SKILLS = [
  {
    title: 'Mémoire',
    text: 'Retrouvez plus facilement noms, listes et détails du quotidien grâce à des exercices de rappel et d’association.',
  },
  {
    title: 'Concentration',
    text: 'Entraînez votre attention soutenue pour rester présent, même lorsque les sollicitations s’accumulent.',
  },
  {
    title: 'Résolution de problèmes',
    text: 'Des défis de logique et de flexibilité mentale pour aiguiser votre jugement et votre créativité.',
  },
  {
    title: 'Équilibre émotionnel',
    text: 'Associez le jeu à des pratiques de pleine conscience pour renforcer calme, résilience et clarté.',
  },
];

export default function Capacites() {
  return (
    <section id="capacites" className="py-20 lg:py-28 bg-pine-600 text-parchment">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-6">
              <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-100">
                Ce que vous exercez
              </p>
              <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
                Un esprit plus vif, un quotidien plus posé.
              </h2>
            </div>
            <p className="lg:col-span-6 text-parchment/75 text-lg leading-relaxed">
              Les jeux Brain IQ et les séances de calme travaillent ensemble :
              d’un côté la clarté cognitive, de l’autre la stabilité intérieure.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-px bg-parchment/15 rounded-2xl overflow-hidden border border-parchment/15">
          {SKILLS.map((skill, i) => (
            <Reveal key={skill.title} delay={i * 70}>
              <article className="bg-pine-600 p-7 sm:p-8 h-full">
                <span className="font-mono text-[11px] text-copper-100">
                  0{i + 1}
                </span>
                <h3 className="mt-3 font-display text-2xl font-semibold">{skill.title}</h3>
                <p className="mt-3 text-parchment/75 leading-relaxed">{skill.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
